'use strict';

export default function f($http, $q, utils, userModel) {
  'ngInject';

  return {
    cancelSubscription(reasons, content) {
      var url = utils.getApiUrl('/membership/' + userModel.item.id + '/disable_recurring');
      return new $q((resolve, reject) => {
        $http.post(url, {
          reasons: reasons,
          content: content,
        }).then((response) => {
          userModel.item.membership = response.data;
          resolve();
        }).catch(reject);
      });
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/membership.js